import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { TenantService } from 'src/app/services/tenant.service';

@Component({
  selector: 'app-nfc-profile-card',
  templateUrl: './nfc-profile-card.component.html',
  styleUrls: ['./nfc-profile-card.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatToolbar],
})
export class NFCProfileCardComponent {
  constructor(
    private router: Router,
    private authService: AuthService,
    public tenantService: TenantService,
  ) {}

  isMenuOpen = false;
  isOpened = false;

  // Method to toggle menu state
  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  startApplication() {
    // Navigate to the first step of the application process
    this.router.navigate(['/nfc-card/build-profile']);
  }

  async signOut(): Promise<void> {
    await this.authService.signOutUser();
  }
}
